import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Separator } from "./styles";
import { CheckBox, Link } from "@ticketmaster/aurora";
import withCss from "webapp-common-ui/src/utils/with-css";

@withCss
export default class SocialShareInfoMessages extends React.Component {
  static propTypes = {
    eventInfo: PropTypes.string.isRequired,
    sendDataToParent: PropTypes.string.isRequired,
    checkBoxRequired: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      hasAcceptedTerms: false,
    };
  }

  termsController = () => {
    this.setState({ hasAcceptedTerms: !this.state.hasAcceptedTerms });
    this.props.sendDataToParent(!this.state.hasAcceptedTerms );
  };

  allInclusivePricingMessage(css) {
    return (
      <div>
        <div className={css.allInPricingInfo1}>
          <FormattedMessage id="social-share.all-in-pricing.info1" />
        </div>
        <div className={css.allInPricingInfo2}>
          <FormattedMessage id="social-share.all-in-pricing.info2" />
        </div>
      </div>
    );
  }

  disableTransferMessage(css) {
    return (
      <div>
        <div className={css.transferDisabledInfo2}><FormattedMessage  id="social-share.transfer-disabled.info2" /></div>
      </div>)
  }

  importantEventInfoMessage(pleaseNote,css) {
    return (
      <div className={css.importantEventInfo}>
        <p>{pleaseNote}</p>
      </div>)
  }

  generalEventInfoMessage(info,css) {
    return (
      <div className={css.generalEventInfo}>
        <p>{info}</p>
      </div>)
  }

  renderEducationFanSection(edpPopup, css) {
    return (
      <div className={css.fanEducationSection}>
        <p>{edpPopup.description}</p>
        {edpPopup.linkUrl && edpPopup.linkText && (
          <div>
            <Link target="_blank" tabIndex="-1" href={edpPopup.linkUrl}>
              {edpPopup.linkText}
            </Link>
          </div>
        )}
        {edpPopup.secondaryLinkUrl && edpPopup.secondaryLinkText && (
          <div>
            <Link
              target="_blank"
              tabIndex="-1"
              href={edpPopup.secondaryLinkUrl}
            >
              {edpPopup.secondaryLinkText}
            </Link>
          </div>
        )}
      </div>
    );
  }

  ageRestriction(ageRuleDescription, css) {
    return (
      <div>
        <div className={css.ageRestrictionTitle}>
          <FormattedMessage id="social-share.age-restriction.title" />
        </div>
        <div className={css.ageRestrictionInfo}>
          {ageRuleDescription}
        </div>
      </div>
    );
  }

  displaySocialShareInfoMessages(eventInfo) {
    return (
      eventInfo &&
      ((eventInfo.edpPopup && eventInfo.edpPopup.forceButtonEnabled) ||
        eventInfo.allInclusivePricing ||
        eventInfo.disableTransfer ||
        eventInfo.info ||
        eventInfo.pleaseNote ||
        eventInfo.ageRestrictions.legalAgeEnforced && eventInfo.ageRestrictions.ageRuleDescription)
    );
  }

  render() {
    const {
      eventInfo,
      checkBoxRequired
    } = this.props;
    const css = this.props.css;

    return (
     this.displaySocialShareInfoMessages(eventInfo) && (
        <div>
          {eventInfo.allInclusivePricing &&
            this.allInclusivePricingMessage(css)}
          {eventInfo.edpPopup &&
            eventInfo.edpPopup.forceButtonEnabled &&
            this.renderEducationFanSection(eventInfo.edpPopup, css)}
          {eventInfo.ageRestrictions.legalAgeEnforced && eventInfo.ageRestrictions.ageRuleDescription &&
            this.ageRestriction(
              eventInfo.ageRestrictions.ageRuleDescription,
              css
            )}
          {eventInfo.disableTransfer && this.disableTransferMessage(css)}
          {eventInfo.pleaseNote && this.importantEventInfoMessage(eventInfo.pleaseNote, css)}
          {eventInfo.info && this.generalEventInfoMessage(eventInfo.info,css)}
          {checkBoxRequired && 
            <div className={css.checkBoxSection} 
            id={css.checkboxid}>
              <CheckBox
                className={css.checkbox}
                size="large"
                name="Accept Terms"
                data-bdd="accept-terms"
                onClick={this.termsController}
                isChecked={this.state.hasAcceptedTerms}
              />
              <FormattedMessage id="social-share.agree" />
            </div>
          }
        </div>
      )
    );
    {
      /* <FormattedMessage
        id="social-share.sub-title.agree"
        values={{
          link: (
            <Link target="_blank" tabIndex="-1" onClick={() => {}}>
              <FormattedMessage id="social-share.sub-title.terms" />
            </Link>
          ),
        }} 
        /> */
    }
  }
}
